import styled from "@emotion/styled/macro";

const NonSolarDisplay = ({
  className,
  src,
  alt,
  dataTestId,
}: {
  className: string;
  src: string;
  alt: string;
  dataTestId: string;
}) => {
  return (
    <NonSolarImgContainer className={className} data-testid={dataTestId}>
      <img src={src} alt={alt} />
    </NonSolarImgContainer>
  );
};

const NonSolarImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 8px;
  background: linear-gradient(180deg, #49517d 0%, #000 100%);
`;

export { NonSolarDisplay };
